jQuery.fn.reverse = [].reverse;

/**
 * Object: list
 * Purpose: parent class for all ajax lists in Curriculog
 */

list = function(types, cui_enabled) {
  //
  var objList = {};
  var cui_enabled = cui_enabled;

  // Set the ajax paramaters.
  var params = {
    display : 'ajax',
    orderBy :'',
    filter : '',
    filterType : '',
    page: '1',
    limit: '10',
    level: 'user'
  }


  //Set the ajax location.
  var URL = document.location.href;

  //Instantiate the dom object
  var domObject = dom(cui_enabled);

  /*
   * Function: listHTML
   * Purpose:
   */
  var listHTML = function(callback) {
    $.ajax({
      url: URL,
      type: 'GET',
      data: params,
      beforeSend: function() {
        $('div.qtip-active').css('display', 'none').removeClass('qtip-active');
      },
      success: function(data) {
        buildDOM(data);
        callback && callback();
      }
    });
  }


  /**
   * Function: buildDOM
   * Purpose: buildDOM takes the HTML data returned from an ajax request to
   *  the ProposalController and loads the new HTML into the DOM.
   *  It is used in the success functions of the list.js ajax.
   */
  var buildDOM = function (data) {
      // `data` should be the HTML returned from a GET request to the proposal controller.
      // Clear the old data.
      $('#curriculog-list-column-results-content').contents().remove();
      $('#curriculog-summary-column').contents().remove();
      $('#curriculog-list-column-results-paging').contents().remove();
      $('#curriculog-summary-column').removeClass('active');



      // check if we are on the needs attention tab
      if($('#curriculog-list-column-tabs .needsattention-tab').hasClass('active')) {
        $('#curriculog-filterby-need').show();
      } else {
        $('#curriculog-filterby-need').hide();
      }

      // check if we are on the approved tab
      if($('#curriculog-list-column-tabs .completed-tab').hasClass('active')) {
        $('#curriculog-filterby-app').show();
      } else {
        $('#curriculog-filterby-app').hide();
      }

      // check if we are on the active tab
      if($('#curriculog-list-column-tabs .manage-proposals-tab').hasClass('active')) {
        $('#curriculog-filterby-act').show();
      } else {
        $('#curriculog-filterby-act').hide();
      }


      // check if we are in proposal list - if so change sort
      if( $('#curriculog-content').hasClass('proposals-page') ) {
        var activeTab = $('#curriculog-list-column-tabs li.active').attr('class').match(/(\w*)-tab/);

        switch(activeTab[1]) {
          case 'tasks':
            var titleSort = 'All Tasks (by name)';
            break;
          case 'mine':
            var titleSort = 'All My Proposals (by name)';
            break;
          case 'watching':
            var titleSort = 'All of My Watch List (by name)';
            break;
          case 'proposals':
            var titleSort = 'All Proposals (by name)';
            break;
          default:
            var titleSort = 'All Tasks (by name)';
        }
        $('#orderBy option[value="proposal_title"]').text(titleSort);
      }

      // Place in the new data.
      $(data).filter('#curriculog-list-column-results-content').contents().appendTo('#curriculog-content #curriculog-list-column-results-content');
      $(data).filter('#curriculog-summary-column').contents().appendTo('#curriculog-content #curriculog-summary-column');
      $(data).filter('#curriculog-list-column-results-paging').contents().appendTo('#curriculog-content #curriculog-list-column-results-paging');

      if( params.page == 1) {
        $('#curriculog-list-column-results-paging button:first').attr('disabled', 'disabled');
      } else {
         $('#curriculog-list-column-results-paging button:first').removeAttr('disabled');
      }

      //Fade items in
      objList.changeItemVisibility();

      // Resize with the new data.
      if ($('#curriculog-content').hasClass('hierarchy-page')) {
        domObject.verticalStretchHierarchy();
      } else {
        domObject.verticalStretchList();
      }

      // Show tooltips again
      $('div.qtip-active').css('display', 'block').addClass('qtip-active');
  };


  /*
   * Function: changeItemVisibility
   * Purpose: Loop though each detail in the list and fade them in one at a time.
   */
  objList.changeItemVisibility = function(callback) {
    // Set the number of details pulled.
    var listQuantity = $('#curriculog-list-column-results-content .open-summary').length;

    $('#curriculog-list-column-results-content .open-summary, #curriculog-list-column-results-content .no-summary').each(function(index) {
      $(this).delay(30 * index).css('visibility','visible').hide().fadeTo(70 * index, 1);
    });

    $('#curriculog-list-column-results-paging').delay(30 * (listQuantity + 1)).css('visibility','visible').hide().fadeTo(70 * (listQuantity + 1), 1, function () {
      callback && callback()
      Curriculog.Actions.log('list-page-loaded');
    });
  }


  /*
   * Function: resetList
   * Purpose:
   */
  objList.resetList = function(newUrl, callback) {
    objList.hideCurrentData();
    params.filter = '';
    params.filterType = '';
    URL = newUrl ? newUrl : URL;
    listHTML(callback);
  }

  /*
   * Function: refreshList
   * Purpose: keep the list in the exact same place
   * Issues: if filter is passed, the request came from a proposal view back to the tab again.
   *     We don't clear that url, since we are ajaxing. So we set it once through the passed filter param
   *     the first time we access the proposal list page, and as the user interacts with
   *    other tabs, the filter param is updated accordingly (ignores the param being passed).
   */
  objList.refreshList = function(filter, callback, deleting) {
    objList.hideCurrentData();
    if ((filter != '') && (params.filter == '')) {
      params.filter = filter;
    }

    var numItems = $('#curriculog-list-column-results-content').children('li').length;

     // its 2 because hideCurrentData adds another li
    if (parseInt(numItems) == 2 && deleting)
      params.page = parseInt(params.page) - 1;

    listHTML(callback);
  }

  /*
   * Function: filterList
   * Purpose:
   */
  objList.filterList = function(pageType, filterType, tab, callback) {
    objList.hideCurrentData();
    //filters: course, program, other, empty
    if (filterType == 'all')
      params.filter = '';
    else
      params.filter = filterType;

    params.page = 1;

    listHTML(callback);

    // Remove the current tab.
    $('#curriculog-list-column-tabs li').removeClass('active');

    // Heighlight the tab.
    $('.'+ tab).addClass('active');
  };

  /**
   * Function: simpleFilter
   * Purpose: The simple filter is the dropdown labelled 'Filter by' on the
   *  Proposal list view. It will render a new proposal list filtered by the
   *  criteria in the select menu.
   */
  objList.simpleFilter = function (refresh, filterId, level) {
    filterId = (filterId !== undefined) ? filterId : '#orderBy';
    level = (level !== undefined) ? level : 'user';

    var activeTab = $('#curriculog-list-column-tabs li.active')
              .prop('class').match(/(\w*)-tab/)[1];
    var filterBy = $(filterId + ' option:selected').val();
    var limit = $('#resultCount option:selected').val();
    var data = {
      tab: activeTab,
      filter: filterBy ? filterBy : params.filter,
      page: refresh ? 1 : params.page,
      limit: limit ? limit : params.limit,
      level: level
    };

    if (refresh) {
      params = $.extend(params, data);
    }

    $.ajax({
      url: '/proposals/simpleFilter',
      type: 'GET',
      data: params,
      beforeSend: function (data) {
        $('div.qtip-active').css('display', 'none').removeClass('qtip-active');
      },
      success: function (data) {
        buildDOM(data);
      }
    });

  };


  /**
   * Function: advancedFilter
   * Purpose: This function processes the Advanced Filter form that appears
   *  after clicking the 'Advanced Filter' link at the top of the proposal
   *  list view, and it renders a new proposal list filtered according to the
   *  critera in the form.
   * Arguments:
   *   - refresh: (boolean) if refresh is true, then reset the page param.
   */
  objList.advancedFilter = function (refresh, level) {
    // Validate the date inputs
    $.validity.start();
    msg = 'This field must be a date formatted mm/dd/yy.'
    $('#report-9-from, #report-9-to').match('date', msg);
    var result = $.validity.end();
    if (! result.valid) return;



    // Parse the advanced filter form
    var formData = {
      activeTab: $('#curriculog-list-column-tabs li.active').attr('class')
                                  .match(/(\w*-?\w*)-tab/)[1],
      entityFilter: $('#report-9-entity-types').val(),
      apFilter: $('#report-9-process-id').val(),
      launchedDateRange: {
        from: $('#report-9-from').val(),
        to: $('#report-9-to').val()
      },
      statuses: $('#filter-9 input[type="checkbox"]:checked').map(function (k, v) {
        return $(v).attr('name').split('-').reverse()[0]
        }).get(),
      keywords: $('#report-9-keyword').val(),
      exportedStatus: $('#report-9-exported-status').val(),
      page: refresh ? 1 : params.page,
      filter: 'advanced',
      level: level ? level : 'user',
    };


    if (refresh) {
      params = $.extend(params, formData);
    }


    // Get the filtered list of proposals and reload the list.
    $.ajax({
      url: '/proposals/advancedFilter',
      type: 'GET',
      data: params,
      beforeSend: function (data) {
        $('div.qtip-active').css('display', 'none').removeClass('qtip-active');
      },
      success: function (data) {
        buildDOM(data);
      }
    });
  }

  /*
   * Function: orderList
   * Purpose:
   */
  objList.orderList = function(orderType) {
    params.orderBy = orderType;
    listHTML();
  }

  /*
   * Function: restrictList
   * Purpose:
   */
  objList.restrictList = function(restrictType, restrictBy, newUrl, callback) {
    objList.hideCurrentData();
    params.filter = restrictBy;
    URL = newUrl ? newUrl : URL;
    params.page = 1
    params.filterType = restrictType;

    listHTML(callback);
  }

  /*
   * Function: hideCurrentData
   * Purpose: show feedback to user so they know the list is loading
   */
  objList.hideCurrentData = function() {
    // Set the number of details pulled.
    var listQuantity = $('#curriculog-list-column-results-content .open-summary, #curriculog-list-column-results-content .no-summary').length;
    var paging = $('#curriculog-list-column-results-paging');
    paging.fadeTo(70 * (listQuantity + 2), 0);
    paging.find('button').attr('disabled', 'disabled');

    $('#curriculog-list-column-results-content .open-summary, #curriculog-list-column-results-content .no-summary').reverse().each(function(index) {
      $(this).delay(30 * (index + 1)).fadeTo(70 * (index + 1), 0);
      if (index === (listQuantity - 1)) {
        if ($('#curriculog-list-column-results-content #detail-0-process').size() < 1) {
          //$('#curriculog-list-column-results-content').prepend('<li class="no-summary" id="detail-0-process"><h3 class="list-name loading">Processing</h3></li>');
          $('#detail-0-process').css('visibility','visible').hide().delay(30 * (index + 2)).fadeTo(70 * (index + 2), 0);
        }
      }
    });

    objList.closeFlyout();

  };

  /**
   * Function: closeFlyout
   * Purpose: Close the flyout.
   */
  objList.closeFlyout = function () {
    $('.open-summary').removeClass('active');
    var listWidth = $('#curriculog-list-column').outerWidth();

    if ($('#curriculog-hierarchy-column').length) {
      listWidth = $('#curriculog-hierarchy-column').outerWidth();
    }

    var detailClosed = listWidth - $('#curriculog-summary-column').outerWidth() - 1;
    $('#curriculog-dashboard-column').addClass('active');
    $('#curriculog-summary-column').animate({'left': detailClosed},
      function() {
        $('.summary.active').removeClass('active');
        $('#curriculog-summary-column').removeClass('active');
        Curriculog.Actions.log('flyout-closed');
      }
    );
   }

  /**
   * Function: isSimpleFilter
   * Purpose: inspect params to see if this request is a simple filter
   */
  objList.isSimpleFilter = function() {
    var simpleFilters = [
      'proposal_status_active',
      'proposal_status_held',
      'proposal_status_suspended',
      'proposal_status_cancelled',
      'proposal_status_completed',
      'proposal_status_unlaunched',
      'proposal_status_waiting',
      'proposal_status_reviewing',
      'proposal_type_course',
      'proposal_type_program',
      'proposal_type_other',
      'urgent',
      'deadline'
    ];

    if ($.inArray(params.filter, simpleFilters) != -1) {
      return true;
    }
    return false;

  }

  /**
   * Function: isAdvancedFilter
   * Purpose: inspect params to see if this request is an advanced filter

  objList.isAdvancedFilter = function() {
    var advancedFilters = [
      'entityFilter',
      'apFilter',
      'launchedDateRange',
      'statuses',
      'keywords',
    ];

    if (params.filter == 'advanced') {
      return true;
    }
    return false;
  }
  */

  /**
   * Function: pageList
   * Purpose: this function gets called when you use the next or previous
   *      pagination buttons.
   */
  objList.pageList = function(pageDirection, filter, newUrl, callback) {
    objList.hideCurrentData();
    params.page = parseInt(params.page) + parseInt(pageDirection);
    params.filter = params.filter ? params.filter : (filter || '');
    URL = newUrl ? newUrl : URL;
    // Call the respective filter function if we are using a simple or
    // advanced filter, else use listHTML.
    if (objList.isSimpleFilter()) {
      return objList.simpleFilter();
    }

    else if (params.filter == 'advanced') {
      return objList.advancedFilter();
    }

    else {
      return listHTML(callback);
    }
  }

  /*
   * Function: pageList
   * Purpose:
   */
  objList.resetPage = function() {
    objList.hideCurrentData();
    params.page = 1;
    listHTML();
  }

  /*
   * Function: resetPage
   * Purpose: resetting the paging params (used for override in hierarchy list)
   */
  objList.overridePage = function() {
    params.page = 1;
  }


  objList.resetFilterList = function(tab) {
    var filter = params.filter
    if (((filter == 'advanced') && (typeof filter !== 'undefined')) && (tab == 'needsattention')){
      params.filter = tab;
    }
    else if (((filter == 'advanced') && (typeof filter !== 'undefined'))  && ((tab == 'approved') || ((tab == 'completed')))){
      params.filter = 'completed';
    }
    else if (((filter == 'advanced') && (typeof filter !== 'undefined'))  && (tab == 'proposals')) {
      params.filter = 'manage-proposals';
    }
  }

  return objList;

};
